import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ColDef, GridApi, GridReadyEvent, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridActionbutton } from 'src/app/shared/common/AgGridActionbutton';
import { GenericBadgeRendererComponent } from 'src/app/shared/common/generic-badge-renderer.component';
import { ReviewActivityPopupConfigComponent } from './review-activity-popup-config/review-activity-popup-config.component';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonPopupSearchComponent } from '../common-popup-search/common-popup-search.component';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-review-activity-config',
    templateUrl: './review-activity-config.component.html',
    styleUrls: ['./review-activity-config.component.scss'],
    standalone: false
})
export class ReviewActivityConfigComponent implements OnInit {

  rowData = []
  components: any={
          buttonRenderer: AgGridActionbutton
  }
   defaultColDef: ColDef = {
      sortable: true,
      resizable: true,
      filter: true,
      filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      }
    };
  columnDefs:ColDef[];

  gridApi: GridApi | null = null;

  pageSize = 10;
  currentPage = 1;
  totalPages = 1;
  totalRows = 0;
  startRow = 1;
  endRow = 10;
  selectedConfigRows: any[] = [];
  defaultActivities:any[] = [];
  constructor(
    private dialog: MatDialog,
    private jsignalsService: JsignalService,
     private snackBar: MatSnackBar,
        private spinner: NgxUiLoaderService,
     private localStorageSettings: LocalStorageSettingsService   

  ) { }



  ngOnInit(): void { 
    this.columnDefs=[
        // {
        //   headerCheckboxSelection: true,
        //   checkboxSelection: true,
        //   width: 100,
        //   pinned: 'left',
        //   lockPosition: true,
        //   onCellClicked: (event: any) => this.onCellClicked(event)
        //   // cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' }
        // },
        { 
          headerName: 'Activity Type', 
          width:200,
          field: 'activityType',
          sortable: true,
          ...this.jsignalsService.autoTooltip('Activity Type'),
          filter: 'agTextColumnFilter'
        },
        { 
          headerName: 'Activity Name', 
          width:200,
          field: 'activityName',
          sortable: true,
          ...this.jsignalsService.autoTooltip('Activity Name'),
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'DataSet Name',
          field: 'datasetName',
           width:200,
           ...this.jsignalsService.autoTooltip('Dataset Name'),
        
        },
        {
          headerName: 'Visual Name',
          field: 'visualName',
           width:200,
           ...this.jsignalsService.autoTooltip('Visual Name'),
        
        },
        {
          headerName: 'Report Template Name',
          field: 'reportName',
           width:200,
           ...this.jsignalsService.autoTooltip('Report Template Name'),
        
        },
        {
          headerName: 'Status',
          field: 'status',
           width:200,
           ...this.jsignalsService.autoTooltip('Status'),
           cellRenderer: GenericBadgeRendererComponent,
            cellRendererParams: { type: 'YES_NO' }
        },
        { 
          headerName: 'Created By', 
          field: 'createdBy',
          width:200,
          sortable: true,
          ...this.jsignalsService.autoTooltip('Created By'),
          filter: 'agTextColumnFilter'
        },
        { 
          headerName: 'Created Date', 
          field: 'createdDate',
          width:200,
          sortable: true,
          ...this.jsignalsService.autoTooltip('Created Date'),
          filter: 'agTextColumnFilter'
        },
        { 
          headerName: 'Modified By', 
          field: 'lastModifiedBy',
          width:200,
          sortable: true,
          ...this.jsignalsService.autoTooltip('Modified By'),
          filter: 'agTextColumnFilter'
        },
        { 
          headerName: 'Modified Date', 
          field: 'lastModifiedDate',
          width:200,
          sortable: true,
         ...this.jsignalsService.autoTooltip('Modified Date'),
          filter: 'agTextColumnFilter'
        },
        // {
        //   headerName: 'STATUS',
        //    width:120,
        //   field: 'status',
        //    tooltipValueGetter: (params) => 'STATUS : ' + params.value,
        //    cellRenderer: GenericBadgeRendererComponent,
        //     cellRendererParams: { type: 'YES_NO' }
        // },
        {
          headerName: 'Actions', 
          filter: false, 
          width:120,
          cellRenderer: 'buttonRenderer',
          pinned:'right',
          lockPinned:true,
          cellRendererParams: {
            edit: this.EditIcon.bind(this),
            delete: this.deleteIcon.bind(this),
          }, 
        }
        // {
        //   headerName: 'ACTIONS',
        //   field: 'actions',
        //   width: 100,
        //   pinned: 'right',
        //   lockPosition: true,
        //   cellRenderer: (params: any) => `
        //     <div class="row-actions">
        //       <i class="pi pi-pencil edit" title="Edit" data-action="edit" data-id="${params.data.id}"></i>
        //       <i class="pi pi-trash delete" title="Delete" data-action="delete" data-id="${params.data.id}"></i>
        //     </div>
        //   `,
        //   onCellClicked: (event: any) => this.onCellClicked(event)
        // }
      ];
      this.loadDefaultActivities();
  }
  onCreate(){
    let dialogRef = this.dialog.open(ReviewActivityPopupConfigComponent, {
      width: "80%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "60%",
      disableClose: true,
      data: {},
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      // this.onGridReady(this.gridApi);
      this.fetchReviewActivityConfig();
    });
  }

  EditIcon(event){

        if (event.rowData.status == "Yes") {
          let dialogRef = this.dialog.open(ReviewActivityPopupConfigComponent, {
            width: "80%",
            autoFocus: false,
            maxWidth: '100vw',
            height: "60%",
            disableClose: true,
            data: {editData: event.rowData},
          });
      
          // subcribe the popup after close
          dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            if(result){
              // this.getVisuals()
             this.spinner.start();
    this.jsignalsService.updateReviewActivityConfig(event.rowData.id, result).subscribe({
      next: (res: any) => {
        this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
        console.log(res);
        this.fetchReviewActivityConfig();
        this.spinner.stop();
      },
      error: (err) => {
        console.error("error:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", {
          duration: 3000,
        });
        this.fetchReviewActivityConfig();
        this.spinner.stop();
      },
    });
   }
            
          });
        } else {
          this.snackBar.open(
            "Cannot edit record which is already deleted.",
            "OK",
            {
              duration: 8000,
            }
          );
        }

  }
  deleteIcon(event){
    if (event.rowData.status == "No"){
      this.snackBar.open("Record is already deleted.", "OK", {
        duration: 8000,
      });
      return;
    }
    this.spinner.start();
     this.jsignalsService.deleteReviewActivityConfig(event.rowData.id).subscribe({
      next: (res: any) => {
        this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
        console.log(res);
        this.fetchReviewActivityConfig();
        this.spinner.stop();
      },
      error: (err) => {
        console.error("error:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", {
          duration: 3000,
        });
        this.fetchReviewActivityConfig();
        this.spinner.stop();
      },
    });

  }

   onGridReady(params: GridReadyEvent): void {
      this.gridApi = params.api;
      this.fetchReviewActivityConfig();

      // Auto-size columns on load
      // setTimeout(() => {
      //   if (this.gridApi) {
      //     this.gridApi.sizeColumnsToFit();
      //   }
      // }, 100);
  
      // Add click event listener for action buttons
      params.api.addEventListener('cellClicked', (event: any) => {
        if (event.column.colId === 'actions') {
          this.onCellClicked(event);
        }
      });
    }


    fetchReviewActivityConfig(){
      this.spinner.start();
    this.jsignalsService.getAllReviewActivityConfigs().subscribe({
        next: (res: any) => {
          console.log("Content loaded:", res);
       
          try {

          this.gridApi.setGridOption('rowData', res);
          this.spinner.stop();

          } catch (error) {
            this.snackBar.open(error, "Ok", { duration: 3000 });
            this.spinner.stop();
          }
        },
        error: (err) => {
          console.error("Error loading Content:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
           this.gridApi.setGridOption('rowData', []);
          this.spinner.stop();
        },
      });
    }
    onCellClicked(event: any): void {
    const target = event.event.target as HTMLElement;
    
    // Check if clicked element is an action button
    if (target.classList.contains('pi')) {
      const action = target.getAttribute('data-action');
      const id = target.getAttribute('data-id');
      const rowData = event.data;
      
      if (action === 'edit') {
        this.onEditRow(rowData);
      } else if (action === 'delete') {
        this.onDeleteRow(rowData);
      }
    }
  }

  onEditRow(rowData: any): void {
    console.log('Edit item:', rowData);
    // Implement single row edit logic
  }

    onDeleteRow(rowData: any): void {
    if (confirm('Are you sure you want to delete this item?')) {
      console.log('Delete item:', rowData);
      // Implement single row delete logic
    }
  }

  clearSelection(): void {
    if (this.gridApi) {
      this.gridApi.deselectAll();
      this.selectedConfigRows = [];
    }
  }
  onEditSelected(): void {
    console.log('Edit selected items:', this.selectedConfigRows);
    // Implement edit logic here
    console.log(this.selectedConfigRows);
    let editData={
      rowData:this.selectedConfigRows[0]
    }
    this.EditIcon(editData);
  }

  onDeleteSelected(): void {
    if (this.selectedConfigRows.length === 0) return;
    
    if (confirm(`Are you sure you want to delete ${this.selectedConfigRows.length} items?`)) {
      console.log('Delete selected items:', this.selectedConfigRows);
      // Implement delete logic here
      this.clearSelection();
    }
  }
  getSelectedCount(): number {
    return this.selectedConfigRows.length;
  }

   onSelectionChanged(event: SelectionChangedEvent): void {
      this.selectedConfigRows = event.api.getSelectedRows();
    }

     goToFirst() {
    this.gridApi.paginationGoToFirstPage();
    this.onPageChange();
  }

  goToPrevious() {
    this.gridApi.paginationGoToPreviousPage();
    this.onPageChange();
  }

  goToNext() {
    this.gridApi.paginationGoToNextPage();
    this.onPageChange();
  }

  goToLast() {
    this.gridApi.paginationGoToLastPage();
    this.onPageChange();
  }

  // 🚀 Call API / analytics / logging here
  onPageChange() {
    console.log('Page changed:', this.currentPage);
    // call backend / emit event / analytics
  }

  onRefresh(){
    this.fetchReviewActivityConfig();
    this.loadDefaultActivities();
  }

  onDownload(){

    this.spinner.start();

    setTimeout(() => {
      this.gridApi.exportDataAsCsv({
        fileName: "Activity_Details.csv",
      });

      this.spinner.stop();
      
    }, 500);
  
  }

  loadDefaultActivities(){
    this.spinner.start();
    this.jsignalsService.getDefaultActivitiesBasedOnWorkSpaceId().subscribe({
      next: (res: any) => {
        if(res.error == true){
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.defaultActivities = [];
          this.spinner.stop();
          return;
        }
    
        console.log(res);
        this.defaultActivities = res;
        this.spinner.stop();
      },
      error: (err) => {
        console.error("error:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", {
          duration: 3000,
        });
        this.defaultActivities = [];
        this.spinner.stop();
      },
    });

  }

  importDefaultActivities(){
    console.log("Importing default activities:", this.defaultActivities);
    if(this.defaultActivities.length === 0){
      console.error("No default activities to import.");
      this.snackBar.open("No default activities to import.", "Ok", { duration: 3000 });
      return;
    }
   let workspaceId = this.localStorageSettings.getSettings("WorkspaceId");
   let dnsid = this.localStorageSettings.getSettings("dnsName"); 

   const dialogRef = this.dialog.open(CommonPopupSearchComponent, {
    width: "50%",
    autoFocus: false,            
    disableClose: true,

    data: {
      edata: this.defaultActivities,

      page: 'multiple',

      hideCheckBox: false,

      selectedValue: [],

      selectedPropertyName: 'activityName',

      title: 'Select Activities',

      columns: [
        {
          activityName: 'Activity Name',
          activityType: 'Activity Type'
        }
      ]
    }
  });

  dialogRef.afterClosed().subscribe(res => {

    if (res.selectedRows <= 0) {
      this.snackBar.open("Please select at least one activity to import.", "Ok", { duration: 3000 });
      return;
    } 

    const defaultActivitiesSelected = res.selectedRows.map(row => ({
      masterActivityId: row.id,
      activityName: row.activityName,
      dnsid: dnsid,
      workspaceid: workspaceId,
      activityType: row.activityType
    }));

    console.log(defaultActivitiesSelected);
    this.insertDefaultActivities(defaultActivitiesSelected); 

  });
         
  }

  insertDefaultActivities(defaultActivities: any[]){
    console.log("Inserting default activities:", defaultActivities);
   this.spinner.start();
    this.jsignalsService.insertReviewActivityConfigDetails(defaultActivities).subscribe({
      next: (res: any) => {
        if(res.error == true){
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
         this.onRefresh();  
          this.spinner.stop();
          return;
        }
    
        console.log(res);
       this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
       this.onRefresh();
        this.spinner.stop();
      },
      error: (err) => {
        console.error("error:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", {
          duration: 3000,
        });
        this.onRefresh();
        this.spinner.stop();
      },
    });
  }
}
